import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import TableCell from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableCell';
import TableRow from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableRow';

const styles = theme => ({
  root: {},
  tableRowHeaderCell: {
    width: '200px',
    borderRight: `1px solid ${theme.palette.grey[300]}`,
    position: 'sticky',
    left: 0,
    backgroundColor: theme.palette.grey[100],
  },
  tableRowSetLabel: {
    color: theme.palette.facet.primaryBlueMuted,
  },
});

const TableRowSetLabel = ({ label, className, classes }) => {
  return (
    <TableRow className={classNames(classes.root, className)}>
      <TableCell className={classes.tableRowHeaderCell}>
        <Typography
          className={classNames(classes.tableRowSetLabel)}
          variant={'h6'}
          weight={'medium'}
          align={'right'}
          test={`facet-plan-allocation-row-label-${label}`}
        >
          {label}
        </Typography>
      </TableCell>
      <TableCell colspan={12} />
    </TableRow>
  );
};

TableRowSetLabel.defaultProps = {
  className: '',
  label: '',
};

TableRowSetLabel.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableRowSetLabel);
